<!-- routify:options bundle=true -->
<!-- routify:options children=[
    {title:"Facebook", path:"//facebook.com/TotalEnergiesBelgium/", icon:"/images/social-icons/facebook.png", showInSocialLinks:true},
    {title:"Twitter", path:"//twitter.com/TotalEnergiesBE", icon:"/images/social-icons/twitter.png", showInSocialLinks:true},
    {title:"LinkedIn", path:"//linkedin.com/company/totalenergies/", icon:"/images/social-icons/linkedin.png", showInSocialLinks:true},
    {title:"Instagram", path:"//instagram.com/totalenergies_be", icon:"/images/social-icons/instagram.png", showInSocialLinks:true},
    {title:"YouTube", path:"//youtube.com/channel/UCXc0jPCckEICHgJlW-HKsRQ", icon:"/images/social-icons/youtube.png", showInSocialLinks:true}
] -->

<script>
    import { onMount } from 'svelte'
    import { redirect, page } from "@sveltech/routify"
    import { config } from '../common/Config'
    import { canActivate } from "../common/Guard"
    import Navigation from '../components/Navigation.svelte'
    import Footer from '../components/Footer.svelte'
    import E403 from './_403.svelte'
    import {
        authStore,
        CookieModal,
        ClearStorageNotification,
        storeHashesAreValid
    } from 'totalinvoice-frontend-core'
    import Cookies from 'js-cookie'

    // user is not logged in and page is guarded -> redirect to login page
    if (!$authStore.authenticated && !$canActivate) {
        $redirect(`/login?dest=${$page.path}`)
    }

    const { key, expires } = config.cookie

    let cookieModalActive = false

    onMount(() => {
        cookieModalActive = Cookies.get(key) !== '1'
    })

    function onCookiesAccepted() {
        Cookies.set(key, '1', { expires })
    }

    const showClearStorageNotification = !storeHashesAreValid()
</script>

<div class="app">
    <Navigation />

    <section class="section">
        <div class="container">
            {#if $canActivate}
                {#if showClearStorageNotification }
                    <div class="mb-6">
                        <ClearStorageNotification active={true} />
                    </div>
                {/if}
                <slot />
            {:else}
                <E403 />
            {/if}
        </div>
    </section>

    <Footer />

    <CookieModal bind:active={cookieModalActive} on:accepted={onCookiesAccepted} />
</div>
